import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/uk/og-uk.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__en-GB.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    title: 'Contents Insurance FAQ • Lemonade Insurance UK',
    metaTitle: 'Contents Insurance FAQ • Lemonade Insurance UK',
    description:
      'Here are some answers to your most common coverage questions - from what contents insurance actually is, to what it covers.',
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
